import { format } from "date-fns";
import { ja } from "date-fns/locale/ja";
import { vi } from "date-fns/locale/vi";
import { enUS } from "date-fns/locale/en-US";
import { zhCN } from "date-fns/locale/zh-CN";
import { ko } from "date-fns/locale/ko";
import type { Locale } from "date-fns";

export const datePickerFormat = "dd LLL, yyyy";

export const dateFormatByLocale: Record<string, string> = {
  ja: "dd'日' M'月' yyyy'年'",
  "zh-tw": "dd'日' M'月' yyyy'年'",
  "ko-kr": "dd'일' M'월' yyyy'년'",
  "en-us": "dd MMM yyyy",
  "zh-cn": "dd'日' M'月' yyyy'年'",
};

export const localeMap: Record<string, Locale> = {
  ja: ja,
  vi: vi,
  en: enUS,
  zh: zhCN,
  ko: ko,
  // Add more locales as needed
};

export const formatDateWithLocale = (
  date: Date | undefined,
  locale: string,
) => {
  if (!date) return "";
  const dateLocale = localeMap[locale] || enUS;
  const formatString = dateFormatByLocale[locale] || datePickerFormat;
  return format(date, formatString, { locale: dateLocale });
};
